const USER_PROFILE = {
    ADMIN: "ADMIN",
    EDITOR: "EDITOR",
    MANAGER: "MANAGER",
  };
  export default USER_PROFILE;
  